import { HttpParams } from '@angular/common/http';
import { Observable, debounceTime, distinctUntilChanged, map } from 'rxjs';

/** `limit`/`offset`/`search` query params for a paginated list endpoint. */
export function pagedQueryParams(query: {
  limit: number;
  offset: number;
  search?: string;
}): HttpParams {
  let params = new HttpParams()
    .set('limit', query.limit.toString())
    .set('offset', query.offset.toString());
  const search = query.search?.trim();
  if (search) {
    params = params.set('search', search);
  }
  return params;
}

/** Turn raw search-box input into debounced, trimmed, de-duplicated terms. */
export function debouncedSearchTerms(
  input$: Observable<string>,
  debounceMs = 300,
): Observable<string> {
  return input$.pipe(
    debounceTime(debounceMs),
    map((value) => value.trim()),
    distinctUntilChanged(),
  );
}
